import { client } from "api";

export type UpdateOrderStatusRequest = { orderId: string; state: string; adminComment: string };
export type UpdateOrderStatusResponse = string;

export const updateOrderStatus = (data: UpdateOrderStatusRequest) =>
  client.post<UpdateOrderStatusResponse>(`/order/admin/approve`, data).then((res) => res.data);
